export default __webpack_public_path__ + "static/media/infoblue.935e87b1.svg";